import React, { useState } from "react";
import logo from "../assets/logo.png";
import styled from "styled-components";
import { GiHamburgerMenu } from "react-icons/gi";
import { VscChromeClose } from "react-icons/vsc";

export default function Navbar() {
	const [navbarState, setNavbarState] = useState(false);
	return (
		<>
			<Nav>
				<div className="brand">
					<div className="container">
						<img className="logo" src={logo} alt="" />
					</div>
					<div className="responsive-title">FLEETLINE TOURS AND TRAVEL</div>
					<div className="toggle">
						{navbarState ? (
							<VscChromeClose onClick={() => setNavbarState(false)} />
						) : (
							<GiHamburgerMenu onClick={() => setNavbarState(true)} />
						)}
					</div>
				</div>
				<ul>
					<li>
						<a href="#home">Home</a>
					</li>
					<li>
						<a href="#aboutus">About</a>
					</li>
					<li>
						<a href="#services">Services</a>
					</li>
					<li>
						<a href="#recommend">Places</a>
					</li>
					<li>
						<a href="#testimonials">Testimonials</a>
					</li>
				</ul>
				<button>Explore</button>
			</Nav>
			<ResponsiveNav state={navbarState}>
				<ul>
					<li>
						<a href="#home" onClick={() => setNavbarState(false)}>
							Home
						</a>
					</li>
					<li>
						<a href="#aboutus" onClick={() => setNavbarState(false)}>
							About
						</a>
					</li>
					<li>
						<a href="#services" onClick={() => setNavbarState(false)}>
							Services
						</a>
					</li>
					<li>
						<a href="#recommend" onClick={() => setNavbarState(false)}>
							Places
						</a>
					</li>
					<li>
						<a href="#testimonials" onClick={() => setNavbarState(false)}>
							Testimonials
						</a>
					</li>
				</ul>
			</ResponsiveNav>
		</>
	);
}

const Nav = styled.nav`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	/* background-color: var(--color-primary);
  height: 80px; */
	.brand {
		.container {
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 0.4rem;
			font-size: 1.2rem;
			font-weight: 900;
			text-transform: uppercase;
			color: #276d9b;
		}
		.logo {
			width: 120px;
			height: 90px;
		}
		.toggle {
			display: none;
		}
		.responsive-title {
			display: none;
		}
	}

	ul {
		display: flex;
		gap: 1rem;
		list-style-type: none;
		li {
			a {
				text-decoration: none;
				color: #39a0e6;
				font-size: 1.2rem;
				transition: 0.1s ease-in-out;
				&:hover {
					//color: #023e8a;
					color: #276d9b;
				}
			}
			&:first-of-type {
				a {
					//color: #023e8a;
					color: #276d9b;
					font-weight: 900;
				}
			}
		}
	}
	button {
		padding: 0.5rem 1rem;
		cursor: pointer;
		border-radius: 1rem;
		border: none;
		color: white;
		//background-color: #48cae4;
		//background-color: green;
		background-color: #39a0e6;
		font-size: 1.1rem;
		letter-spacing: 0.1rem;
		text-transform: uppercase;
		transition: 0.3s ease-in-out;
		&:hover {
			//background-color: #023e8a;
			//background-color: darkgreen;
			background-color: #276d9b;
		}
	}
	@media screen and (max-width: 1080px) {
		.brand {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			.toggle {
				display: block;
				cursor: pointer;
			}
			.responsive-title {
				display: block;
				font-size: 32px;
				font-weight: bold;
			}
		}

		ul {
			display: none;
		}
		button {
			display: none;
		}
	}

	@media screen and (max-width: 768px) {
		.brand {
			.responsive-title {
				font-size: 18px;
			}
		}
	}
	@media screen and (max-width: 520px) {
		.brand {
			.responsive-title {
				font-size: 16px;
			}
		}
	}
	@media screen and (max-width: 460px) {
		.brand {
			.responsive-title {
				display: none;
			}
		}
	}
`;

const ResponsiveNav = styled.div`
	display: flex;
	position: absolute;
	z-index: 1;
	top: ${({ state }) => (state ? "50px" : "-400px")};
	background-color: white;
	height: 30vh;
	width: 100%;
	align-items: center;
	transition: 0.3s ease-in-out;
	ul {
		list-style-type: none;
		width: 100%;
		li {
			width: 100%;
			margin: 1rem 0;
			margin-left: 2rem;

			a {
				text-decoration: none;
				color: #39a0e6;
				font-size: 1.2rem;
				transition: 0.1s ease-in-out;
				&:hover {
					color: #276d9b;
				}
			}
			&:first-of-type {
				a {
					color: #276d9b;
					font-weight: 900;
				}
			}
		}
	}
`;
